// src/services/pageService.js
import apiClient from "./apiClient";

// Default fallback data for different pages
const defaultAboutPageData = {
    seo: {
      title: "About Us | Softition",
      description:
        "Learn more about Softition, a modern software studio focused on delivering scalable, efficient, and elegant solutions for businesses worldwide.",
      canonical: "https://softition.com/about",
    },
    hero: {
      heading: "About",
      highlight: "Softition",
      description:
        "Where innovation meets excellence — crafting digital experiences that inspire, empower, and deliver results.",
    },
};

// Default fallback data for Home page
const defaultHomePageData = {
  seo: {
    title: "Softition | Software Development, IT Services & Digital Solutions",
    description:
      "Softition delivers scalable, elegant, and efficient solutions including web apps, mobile apps, e-commerce, and IT services.",
    canonical: "https://softition.com/",
  },
  hero: {
    heading: "Custom solutions to streamline your modern business operations",
    highlight: "Softition",
    description:
      "Empowering businesses with cutting-edge technology, elegant design, and measurable results.",
  },
};

// Default fallback data for Services page
const defaultServicesPageData = {
  seo: {
    title: "Our Services | Softition",
    description:
      "Explore Softition's services including Web Development, Mobile Apps, E-Commerce Solutions, Cloud, and IT Consulting.",
    canonical: "https://softition.com/services",
  },
  hero: {
    heading: "Our",
    highlight: "Services",
    description:
      "We provide innovative and scalable digital solutions.",
  },
};

// Default fallback data for Services page
const defaultContactPageData = {
  seo: {
    title: "Contact Us | Softition",
    description:
      "Get in touch with Softition for software development, IT consulting, or collaboration opportunities. We’d love to hear from you!",
    canonical: "https://softition.com/contact",
  },
  hero: {
    heading: "Get in",
    highlight: "Touch",
    description:
      "We’d love to hear from you — whether it’s a new project, a collaboration, or simply a quick hello, our team is ready to connect and bring your ideas to life.",
  },
};

// Default fallback data for projects page
const defaultProjectsPageData = {
  seo: {
    title: "Our Projects | Softition",
    description:
      "Take a look at the successful projects delivered by Softition, from web apps to enterprise-scale solutions.",
    canonical: "https://softition.com/projects",
  },
  hero: {
    heading: "Our",
    highlight: "Projects",
    description:
      "Discover how we deliver real-world impact through digital innovation.",
  },
};

// Switch-based fallback
const getDefaultPageData = (page) => {
  switch (page) {
    case "about":
      return defaultAboutPageData;
    case "home":
      return defaultHomePageData;
    case "services":
          return defaultServicesPageData;
    case "contact":
          return defaultContactPageData;
    case "projects":
          return defaultProjectsPageData;
      
    default:
      return {};
  }
};

// Generic fetcher for any page
export const getPageData = async (page) => {
  try {
    const response = await apiClient.get(`/page/${page}`);
    return response.data;
  } catch (error) {
      console.error(`Error fetching ${page} page data:`, error);
      //throw error; // rethrow so component can handle it
      return getDefaultPageData(page);
  }
};
